import * as React from 'react';
import {
  getSmoothStepPath,
  EdgeLabelRenderer,
  BaseEdge,
  type EdgeProps,
  type Edge as EdgeType,
} from '@xyflow/react';
import { UtilityText } from '@leagueplatform/genesis-core';

export const Edge: React.FC<EdgeProps<EdgeType<{ label: string }>>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  label,
  selected,
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd="url(#custom-edge-arrow)"
        style={{
          strokeWidth: 2,
          stroke: `${
            selected
              ? 'var(--GDS-colors-onSurfaceBorderDefault)'
              : 'var(--GDS-colors-onSurfaceBorderSubdued)'
          }`,
        }}
      />
      {label ? (
        <EdgeLabelRenderer>
          <UtilityText
            size="eyebrow"
            css={{
              position: 'absolute',
              backgroundColor: '$surfaceBackgroundSecondary',
              paddingX: '$half',
              color: '$onSurfaceTextPrimary',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            }}
          >
            {label}
          </UtilityText>
        </EdgeLabelRenderer>
      ) : null}
    </>
  );
};
